import React from "react";
import "./RotateDeviceOverlay.css";

/**
 * RotateDeviceOverlay
 *
 * Fallback visual cuando la Screen Orientation API no puede bloquear la orientación.
 * Aparece sobre toda la pantalla cuando el dispositivo está en landscape
 * en páginas que solo deben verse en portrait.
 *
 * Se muestra/oculta mediante el prop `show` que proviene de useOrientationLock.
 */
const RotateDeviceOverlay = ({ show }) => {
  if (!show) return null;

  return (
    <div className="rotate-overlay" role="alert" aria-live="polite">
      <div className="rotate-overlay__content">
        <div className="rotate-overlay__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            {/* Ícono de teléfono rotando */}
            <rect x="4" y="2" width="11" height="17" rx="2" ry="2" />
            <path d="M20 7l-3-3-3 3" />
            <path d="M17 4v9a2 2 0 0 1-2 2H7" />
          </svg>
        </div>
        <p className="rotate-overlay__text">
          Por favor, gira tu dispositivo a modo vertical. Dentro de tu curso podrás usarlo en cualquier orientación.
        </p>
      </div>
    </div>
  );
};

export default RotateDeviceOverlay;
